import {APP_PREFIX_PATH} from "../AppConfig";
import React from "react";

export const authenticationRoutes = [
    {
        key: 'login-1',
        path: `${APP_PREFIX_PATH}/login-1`,
        component: React.lazy(() => import('views/auth-views/authentication/login-1')),
        meta: {
            blankLayout: true
        }
    },
    {
        key: 'forgot-password',
        path: `${APP_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
        meta: {
            blankLayout: true
        }
    },
    {
        key: 'update-password',
        path: `${APP_PREFIX_PATH}/setting/update-password`,
        component: React.lazy(() => import('views/auth-views/update-password'))
    },
]